var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"find-index"},[_c('keep-alive',{attrs:{"include":"findIndex"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }